module.exports = __webpack_public_path__ + "static/media/def_no_zoom.7850f6d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/def_no_zoom.png
// module id = 113
// module chunks = 0